module.exports = __webpack_public_path__ + "img/bg-car-dark.583511de.png";